import { styled } from "@mui/material";
import IconButton from "components/IconButton";
import Typography from "components/Typography";

export const OneRepMaxEntriesTableRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
  padding: theme.spacing(0, 3, 3, 2),
}));

export const OneRepMaxEntriesTableHeaderRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  width: "100%",
  padding: theme.spacing(3, 0, 1.75, 0),
}));

export const OneRepMaxEntriesTableHeading = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  flex: "1 0 0",
}));

export const OneRepMaxEntriesTableToolbar = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

// Neutral at rest so a column of delete buttons doesn't read as an alert; red once it's targeted.
export const OneRepMaxTableAction = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[120],

  "&:hover, &.Mui-focusVisible": {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
}));

export const OneRepMaxEntryValue = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.main,
}));

export const OneRepMaxEntryAuthor = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[100],
}));
